import React, { Ref, forwardRef } from 'react';
import MaterialTable, { MaterialTableProps } from '@material-table/core';

import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { Tooltip } from '@mui/material';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

const tableIcons = {
  Add: forwardRef((props, ref: Ref<any>) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref: Ref<any>) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref: Ref<any>) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref: Ref<any>) => (
    <DeleteOutline {...props} ref={ref} />
  )),
  DetailPanel: forwardRef((props, ref: Ref<any>) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref: Ref<any>) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref: Ref<any>) => (
    <SaveAlt {...props} ref={ref} />
  )),
  Filter: forwardRef((props, ref: Ref<any>) => (
    <FilterList {...props} ref={ref} />
  )),
  FirstPage: forwardRef((props, ref: Ref<any>) => (
    <FirstPage {...props} ref={ref} />
  )),
  LastPage: forwardRef((props, ref: Ref<any>) => (
    <LastPage {...props} ref={ref} />
  )),
  NextPage: forwardRef((props, ref: Ref<any>) => (
    <ChevronRight {...props} ref={ref} />
  )),
  PreviousPage: forwardRef((props, ref: Ref<any>) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref: Ref<any>) => (
    <Clear {...props} ref={ref} />
  )),
  Search: forwardRef((props, ref: Ref<any>) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref: Ref<any>) => (
    <ArrowDownward {...props} ref={ref} />
  )),
  ThirdStateCheck: forwardRef((props, ref: Ref<any>) => (
    <Remove {...props} ref={ref} />
  )),
  ViewColumn: forwardRef((props, ref: Ref<any>) => (
    <ViewColumn {...props} ref={ref} />
  )),
};

type SimpleTableProps = MaterialTableProps<any> & {
  emptyState?: React.ReactNode;
};

// https://material-table.com/#/
export const SimpleTable = ({ emptyState, ...props }: SimpleTableProps) => (
  <MaterialTable
    {...props}
    options={
      {
        toolbar: false,
        sorting: false,
        pageSizeOptions: [10, 25, 50],
        pageSize: window.innerHeight > 800 ? 25 : 10,
        emptyRowsWhenPaging: false,
        ...props.options,
      } as any
    }
    localization={{
      ...props.localization,
      body: {
        ...props.localization?.body,
        emptyDataSourceMessage: emptyState,
      },
    }}
    icons={tableIcons}
  />
);

type ColumnHeaderProps = {
  title: string;
  label: string;
};
export const ColumnHeader = ({ title, label }: ColumnHeaderProps) => {
  return (
    <Tooltip
      title={
        <p
          className="whitespace-pre-wrap"
          dangerouslySetInnerHTML={{
            __html: typeof title === 'string' ? title : 'INVALID_TITLE',
          }}
        />
      }
    >
      <span className="flex items-center">
        {label}
        <Icon icon={faCircleInfo} className="mx-2" />
      </span>
    </Tooltip>
  );
};
